import React from 'react';

import { ProfileDM } from '../../common/interfaces';
import Imgix from "react-imgix";
import {getEpochFromDate, onClickProfile} from "../../common/services/logic-provider";
import {AVATAR_PATH} from "../../common/constants";
import VerifiedIcon from "../../../../ui/svg/common/verified";

export interface CreatorItemProps {
    creator:ProfileDM;
    imgCdnDomain:string;
    creatorsPath:string;
    imgWidth?:number;
    imgHeight?:number;
    isDarkBackground?:boolean;
    cancelImgLazyload?:boolean;

}
const CreatorItem = (props:CreatorItemProps) => {



    return (
        <div className={props.isDarkBackground ? "text-white":""}  style={props.imgWidth ? {width:props.imgWidth + "px"}:{}}>
            <div className="w-full">
                <button type="button" className="cursor-pointer" onClick={() => onClickProfile(props.creator)} >
                    {props.creator.imgExt.length > 0 ?
                        <Imgix
                            className="w-full rounded-full overflow-hidden"
                            src= {props.imgCdnDomain + "/" +
                                props.creatorsPath +
                                props.creator.prfUserGUID + "." +
                                props.creator.imgExt  + "?epoch=" + getEpochFromDate(props.creator.itemModifiedWhen)}
                            width={props.imgWidth !== null ? props.imgWidth : 300}
                            height={props.imgHeight !== null ? props.imgHeight :300}
/*
                            imgixParams={{ mask:"ellipse" }}
*/
                            htmlAttributes={{
                                alt: `${ props.creator.publicName } profile image`,
                                loading: props.cancelImgLazyload ? undefined : 'lazy',
                            }}
                        />
                        :
                        <Imgix
                            src= {props.imgCdnDomain + AVATAR_PATH }
                            width={props.imgWidth !== null ? props.imgWidth : 300}
                            height={props.imgHeight !== null ? props.imgHeight :300}
                            imgixParams={{ mask:"ellipse" ,facepad:"1.9",fit: "facearea"}}
                            htmlAttributes={{
                                alt: `${ props.creator.publicName } profile image`,
                                loading: props.cancelImgLazyload ? undefined : 'lazy',
                            }}
                        />
                    }
                </button>

            </div>
            <div className="w-full">
                <div className="w-full font-medium mt-6 flex items-center justify-center">
                    <div  className={`cursor-pointer no-underline flex items-center ${props.isDarkBackground ? "text-white" : "text-black"}`}
                          onClick={() => onClickProfile(props.creator)} >
                        <div className="w-ellipsis">{props.creator.publicName}</div>
                        {props.creator.isVerified &&
                            <div className="ml-1">
                                <VerifiedIcon width="15px" />
                            </div>
                        }

                    </div>
                </div>
                <div className="w-full flex items-center justify-center" >
                    <div  className={`cursor-pointer no-underline w-ellipsis ${props.isDarkBackground ? "text-white" : "text-black"}`}
                          onClick={() => onClickProfile(props.creator)} >
                        @{props.creator.handle}
                    </div>
                </div>
            </div>

        </div>


    )
};

export default CreatorItem;